// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"3babe802","226":"35499b23","229":"032d4ca8","257":"c027ca2c","378":"522af1cd","404":"61a01053","453":"31bf9d75","565":"80301f64","599":"49c5693b","773":"5c64cacc","869":"43e40e4d"}[chunkId] + ".chunk.js";
};